import { captureError, identify, init } from "./index";

// Script-tag entry: <script src="https://<worker>/sdk.js" data-key="pk_…" async></script>
// Optional attributes: data-widget="false", data-console="false", data-network="false",
// data-release="1.4.2", data-attributes="data-feedback-id,data-testid".
const script = document.currentScript as HTMLScriptElement | null;
const d = script?.dataset ?? {};
(window as any).AgenticFeedback = { init, captureError, identify };
if (script && d.key) {
  init({
    key: d.key,
    endpoint: d.endpoint ?? new URL(script.src).origin,
    widget: d.widget !== "false",
    console: d.console !== "false",
    network: d.network !== "false",
    release: d.release,
    screenshots: d.screenshots !== "false",
    hotkey: d.hotkey === "false" ? false : d.hotkey || undefined,
    attributes: d.attributes?.split(",").map((s) => s.trim()).filter(Boolean),
  });
}
